import { useContext, useMemo } from "react";
import clsx from "clsx";
import { usePage, useSection } from "@tree-company/tree-query";
import { LocaleContext } from "../app";
import { Button } from "./button";
import { usePageEffects } from "../hooks/use_page_effects";
import { recommendationKeys, ratingKey } from "../survey";
import { Progress } from "./recommendation/progress";
import { InfoDialogButton, InfoDialog } from "./recommendation/info_dialog";

export function RecommendationPage({
  className,
  page,
  children,
  handleSave,
  onPreviousPage,
}) {
  const { translate } = useContext(LocaleContext);
  const { title, htmlAttributes, key } = usePage(page);
  usePageEffects({ key });
  const ratingSection = useMemo(
    () => page.sections.find((s) => s.key === ratingKey(page.key)),
    [page],
  );
  const { value: ratingValue } = useSection(ratingSection);
  // Infer submitted pages with key present (even if skipped e.g. null)
  const previouslySubmitted = ratingSection.key in page.treesponse.answers;
  const nextDisabled = !previouslySubmitted && ratingValue === null;

  function onSkip(e) {
    // may change nextDisabled and therefore skip button type may not submit
    ratingSection.value = null;
    handleSave(e);
  }

  return (
    <form
      className={clsx(
        className,
        "page",
        "page--recommendation",
        htmlAttributes.class,
      )}
      onSubmit={handleSave}
    >
      <div className="page__main">
        <Progress step={page.order} total={recommendationKeys.length} />
        <div className="recommendation__main">
          <div className="recommendation__half">
            <p className="recommendation__navtitle">
              {translate(`recommendations.${page.key}.navigation_title`)}
            </p>
            {title && <h1 className="recommendation__title">{title}</h1>}
            <InfoDialogButton pageKey={page.key} />
            <InfoDialog pageKey={page.key} />
          </div>
          <div className="recommendation__half">
            <p className="recommendation__question">
              {translate("recommendations.page.question")}
            </p>
            {children}
            <Button
              type={nextDisabled ? "submit" : "button"}
              variation="clear"
              className="page__action page__action--skip"
              onClick={onSkip}
            >
              {translate("navigation.skip")}
            </Button>
          </div>
        </div>
      </div>
      <div className="page__actions">
        <Button
          variation="clear"
          className="page__action page__action--previous"
          onClick={onPreviousPage}
          iconPrev
          srText
        >
          {translate("navigation.previous")}
        </Button>
        <Button
          type={nextDisabled ? "button" : "submit"}
          variation="clear"
          className="page__action page__action--next"
          disabled={nextDisabled}
          iconNext
          srText
        >
          {translate("navigation.next")}
        </Button>
      </div>
    </form>
  );
}
